import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Select,
  Switch,
  Col,
  Row,
  Card,
  Space,
  Tabs,
  Popconfirm,
  Typography,
  InputNumber,
  Upload,
  message,
  Flex,
  Drawer,
  Spin,
} from "antd";
import Table from 'components/Common/Table';
import fileDownload from "js-file-download";
import * as adminactions from "store/actions/AuthActions";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  InboxOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PrinterOutlined,
  EyeOutlined,
  ReloadOutlined,
  EditOutlined,
  CopyOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";
import { CKEditor } from "ckeditor4-react";
import axios from "axios";
import { DocumentPicker } from "components";
import { useSelector } from "react-redux";
import { dateFormat } from "constants/constants";
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import PdfPreviewModal from "components/PdfPreviewModal/PdfPreviewModal";

import QuoteLineForm from "./QuoteLineForm";
import QuoteServiceForm from "./QuoteServiceForm";
import SendQuoteDrawer from "./SendQuoteDrawer";
import ImportQuoteLinesModal from "./ImportQuoteLinesModal";
import PreviewDrawerActions from "components/Common/PreviewDrawerActions";
import PdfViewer from "components/Common/PdfViewer";
import ExchangeRateInput from "components/Common/ExchangeRateInput";
import { compactToolbar } from "utilities/config";
import { nextLineKey, serializeLines, withLineKeys } from "utilities/quoteLines";
import { exportQuoteLines } from "api/api";
import { roundPayable } from "utils/money";
import {
  DISCOUNT_TYPE_OPTIONS,
  discountAmountOf,
  formatDiscount,
} from "utilities/discount";

const { Dragger } = Upload;

const QuoteForm = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const dealIdFromUrl = searchParams.get('deal');

  const [dataSource, setDataSource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [deals, setDeals] = useState([]);
  const [, setSelectedDeal] = useState(null);
  const [taxRates, setTaxRates] = useState([]);
  const [, setProductCount] = useState(0);
  const [, setServiceCount] = useState(0);
  const [isManual, setIsManual] = useState(false);
  // const [products, setProducts] = useState([]);
  // const [services, setServices] = useState([]);
  const [net, setNet] = useState([]);
  // const [subtotal, setSubTotal] = useState([]);
  const [roundValue, setRoundValue] = useState(0);
  const [unRoundedTotal, setUnRoundedTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [totalTaxes, setTotalTaxes] = useState({});
  const [taxRate1, setTaxRate1] = useState(null);
  const [taxRate2, setTaxRate2] = useState(null);
  const [taxRate3, setTaxRate3] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [quoteStatuses, setQuoteStatuses] = useState([]);
  const [tesonProducts, setTesonProducts] = useState([]);
  const [previewPdfVisible, setPreviewPdfVisible] = useState(false);
  const [pdfPreviewData, setPdfPreviewData] = useState(null);


  const [mainForm] = Form.useForm();
  const selectedCurrencyId = Form.useWatch("currency", mainForm);
  const boundaryPrice = Form.useWatch("boundary_price", mainForm);
  const discountType = Form.useWatch("discount_type", mainForm);
  const discountValue = Form.useWatch("discount_value", mainForm);

  // const [form] = Form.useForm();

  const [productForm] = Form.useForm();
  const [openProductForm, setOpenProductForm] = useState(false);
  const [currentProductInstance, setCurrentProductInstance] = useState(null);
  const [serviceForm] = Form.useForm();
  const [openServiceForm, setOpenServiceForm] = useState(false);
  const [currentServiceInstance, setCurrentServiceInstance] = useState(null);

  const [currencies, setCurrencies] = useState([]);
  const selectedCurrencyIso =
    currencies.find((currency) => currency.id === selectedCurrencyId)?.iso_code || null;
  const isForeignCurrency = !!selectedCurrencyIso && selectedCurrencyIso !== "INR";
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [quoteItemData, setQuoteItemData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [totalHours, setTotalHours] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [openSendDrawer, setOpenSendDrawer] = useState(false);
  const [openViewDrawer, setOpenViewDrawer] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [exporting, setExporting] = useState(false);
  // Whether the current isManual value arrived from the server rather than the
  // user flipping the toggle.
  const loadedIsManualRef = useRef(null);
  const organization = useSelector((state) => state.auth.organization);

  const [editingKey, setEditingKey] = useState("");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [deliveryTimelineUnits, setDeliveryTimelineUnits] = useState([]);

  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);

  const isEditing = (record) => record.key === editingKey;

  const events = {
    onDocumentLoadSuccess: ({ numPages }) => {
      setNumPages(numPages);
    },
  };

  const onFinish = (values) => {
    console.log("Success:", values);

    // Saved lines keep their id so the backend updates them in place; anything
    // else is a new line. Priority follows the on-screen order.
    const modifiedProductData = serializeLines(
      Array.isArray(quoteItemData) ? quoteItemData : []
    );
    const modifiedServiceData = serializeLines(
      Array.isArray(serviceData) ? serviceData : []
    );

    if (values) {
      // Use environment variable as primary source, fallback to Redux state
      const orgId = process.env.REACT_APP_ORGANIZATION_UUID || organization;

      // onSaveHandler({ ...values, organization: organization, quote_date: values?.quote_date.format(dateFormat), expiry_date: values?.expiry_date.format(dateFormat), quoteitem_set: quoteItemData, quoteservice_set: serviceData, net: net, total: total })
      onSaveHandler({
        ...values,
        organization: orgId,
        // A cleared Select is undefined, which would leave the old product in place.
        product: values?.product ?? null,
        quote_date: values?.quote_date.format(dateFormat),
        expiry_date: values?.expiry_date.format(dateFormat),
        quoteitem_set: [...modifiedProductData],
        quoteservice_set: [...modifiedServiceData],
        net: net,
        total: total,
        // The rate field only shows for foreign currencies; INR is always 1.
        exchange_rate: isForeignCurrency ? values?.exchange_rate : 1.0,
        // A cleared Select is undefined, which would leave the old discount in place.
        discount_type: values?.discount_type || null,
        discount_value: values?.discount_type ? values?.discount_value || 0 : 0,
        show_bank_details: values?.show_bank_details ? values?.show_bank_details : false,
        is_authorized_signature_required: values?.is_authorized_signature_required ? values?.is_authorized_signature_required : false,
        is_computer_generated: values?.is_computer_generated !== undefined ? values?.is_computer_generated : true
      });
    }
  };

  const loadQuote = async () => {
    if (id) {
      const response = await adminactions.loadQuote(id);
      console.log(response);
      if (response) {
        console.log("Changing state now...");
        setDataSource(response);
        // Lines arrive in priority order; keys and priorities are renumbered
        // from that order so both are dense and unique.
        const sortedItems = [...(response.quoteitem_set || [])].sort(
          (a, b) => (a.priority || 0) - (b.priority || 0)
        );
        setQuoteItemData(withLineKeys(sortedItems));
        setServiceData(withLineKeys(response.quoteservice_set || []));
        setDocuments(response.documents);
        setAttachments(response.attachments);
        // Remember that this value came from the server, not from the user
        // flipping the toggle — see the effect that clears the lines.
        loadedIsManualRef.current = response.is_manual;
        setIsManual(response.is_manual);
        setNet(response.net);
        setTotal(response.total);
        setTaxRate1(response.tax_rate1_data);
        setTaxRate2(response.tax_rate2_data);
        setTaxRate3(response.tax_rate3_data);

        // Load bank accounts for the quote's organization
        if (response.organization) {
          loadBankAccounts(response.organization);
        }
      }
    }
    setLoading(false);
  };

  const loadAccounts = async () => {
    const response = await adminactions.loadAccounts(1, undefined, 1000);
    if (response.status === 200) {
      setAccounts(response.data.results);
    }
  };

  const loadDeals = async (accountId = null) => {
    try {
      const response = await axios.get('/deals/deals/', {
        params: accountId ? { account: accountId } : {}
      });
      if (response.status === 200) {
        setDeals(response.data.results || response.data);
      }
    } catch (e) {
      console.log("Error loading deals:", e);
    }
  };

  const loadDealById = async (dealId) => {
    try {
      const response = await axios.get(`/deals/deals/${dealId}/`);
      if (response.status === 200) {
        const deal = response.data;
        setSelectedDeal(deal);
        // Pre-fill account and deal in the form
        mainForm.setFieldsValue({
          account: deal.account,
          deal: deal.id
        });
        // Load deals for the account
        loadDeals(deal.account);
      }
    } catch (e) {
      console.log("Error loading deal:", e);
    }
  };

  const loadQuoteStatuses = async () => {
    const response = await adminactions.loadQuoteStatuses();
    if (response) {
      setQuoteStatuses(response);
    }
  };

  const loadDeliveryTimelineUnits = async () => {
    const response = await adminactions.loadDeliveryTimelineUnits();
    if (response) {
      setDeliveryTimelineUnits(response);
    }
  };

  const loadBankAccounts = async (orgId) => {
    // Use .env organization ID as the primary source for bank accounts
    // This ensures bank accounts are always fetched for the configured organization
    const envOrgId = process.env.REACT_APP_ORGANIZATION_UUID;
    const organizationId = envOrgId || orgId || organization;

    if (!organizationId) {
      console.error("❌ No organization ID available to load bank accounts");
      console.error("   - .env REACT_APP_ORGANIZATION_UUID:", envOrgId);
      console.error("   - orgId parameter:", orgId);
      console.error("   - Redux organization:", organization);
      console.error("   ⚠️  Please set REACT_APP_ORGANIZATION_UUID in .env file");
      return;
    }

    console.log("✅ Loading bank accounts for organization:", organizationId);
    try {
      const response = await adminactions.loadBankAccounts(organizationId);
      if (response && Array.isArray(response)) {
        console.log("✅ Bank accounts loaded:", response.length, "accounts");
        setBankAccounts(response);
        // Set first bank account as default for new quotes
        if (!id && response.length > 0 && !mainForm.getFieldValue("org_bank_account")) {
          mainForm.setFieldValue("org_bank_account", response[0].id);
        }
      } else {
        console.error("❌ Failed to load bank accounts - invalid response");
      }
    } catch (error) {
      console.error("❌ Error loading bank accounts:", error);
    }
  };

  const loadTesonProducts = async () => {
    try {
      const response = await adminactions.loadPaymentProducts();
      if (response.status === 200) {
        setTesonProducts(response.data.results || response.data || []);
      }
    } catch (e) {
      console.error("Error loading products:", e);
    }
  };

  const loadCurrencies = async () => {
    const response = await axios.get("/masters/currencies/");
    if (response.status === 200) {
      setCurrencies(response.data);
    }
  };

  // const loadProducts = async () => {
  //     const response = await adminactions.loadProducts();
  //     if (response) {
  //         setProducts(response);
  //     }
  // }

  // const loadServices = async () => {
  //     const response = await adminactions.loadServices();
  //     if (response) {
  //         setServices(response);
  //     }
  // }

  const loadTaxRates = async () => {
    const response = await adminactions.loadTaxRates();
    if (response) {
      setTaxRates(response);
    }
  };

  const loadGeneratedQuoteNumber = async () => {
    // Use .env organization ID as the primary source
    const envOrgId = process.env.REACT_APP_ORGANIZATION_UUID;
    const orgId = envOrgId || organization;

    if (orgId) {
      const response = await adminactions.generateQuoteNumber(orgId);
      if (response && response.quote_number) {
        mainForm.setFieldValue("qt_number", response.quote_number);
      }
    }
  };

  const onSaveHandler = async (values) => {
    setSubmitting(true);
    try {
      console.log("VALUES", values);
      if (id) {
        // Cleared fields are sent as null so the backend overwrites the old
        // value instead of keeping it. Numbers and the line arrays are exempt:
        // nulling `net` on a zero total, or `quoteitem_set` on an empty list,
        // rejects the whole save or wipes the lines.
        const preserved = ["quoteitem_set", "quoteservice_set", "net", "total"];
        Object.keys(values).forEach((k) => {
          if (preserved.includes(k)) {
            return;
          }
          if (!values[k] && values[k] !== false && values[k] !== 0) {
            values[k] = null;
          }
        });

        const response = await adminactions.updateQuotes(values, id);
        console.log(response);
        if (response) {
          // navigate("/quotes")
          message.success("Quote updated successfully!");
          setHasUnsavedChanges(false);
          // Re-read the saved lines so the form holds the ids the backend just
          // assigned; without that the next save treats new lines as new again.
          await loadQuote();
        } else {
          message.error("Failed to update!");
        }
      } else {
        const response = await adminactions.addQuotes(values);
        if (response) {
          setHasUnsavedChanges(false);
          navigate("/quotes/edit/" + response.id);
        }
      }
    } finally {
      setSubmitting(false);
    }
  };

  const getTaxes = (object) => {
    const string = [];
    for (const [key, value] of object) {
      string.push({ key: key, value: value });
    }
    return string;
  };

  const onAccountChange = (value) => {
    console.log(`selected ${value}`);
  };

  const onAccountSearch = (value) => {
    console.log("search:", value);
  };

  const previewDownloadPdf = async (preview, download) => {
    const response = await adminactions.downloadQuote(
      id,
      true,
      "QUOTE_TEMPLATE"
    );
    console.log({ response });
    if (response) {
      if (download) {
        const filename = dataSource?.qt_number ? `${dataSource.qt_number}.pdf` : "quote.pdf";
        fileDownload(response, filename);
      }
      if (preview) {
        setPdfPreviewData(response);
        setPreviewPdfVisible(true);
      }
    }
  };

  const cloneQuote = async (id) => {
    const response = await adminactions.cloneQuote(
      id
    );
    console.log({ response });
    if (response) {
      window.location.href = `/quotes/edit/${response.id}`;
    }
  };

  const convertToInvoice = async (id) => {
    const response = await adminactions.convertQuoteToInvoice(id, {});
    console.log({ response });
    if (response) {
      message.success(`Quote converted to Invoice ${response.inv_number}`);
      window.location.href = `/invoices/edit/${response.id}`;
    }
  };

  const deleteRecord = (recordkey, type) => {
    switch (type) {
      case "product":
        updateQuoteItemData((prev) => prev.filter((item) => item.key !== recordkey));
        break;
      case "service":
        updateServiceData((prev) => prev.filter((item) => item.key !== recordkey));
        break;
      default:
        console.error("Error occurred");
    }
  };

  const cloneLineItem = (record, type) => {
    // A clone is a new line: it gets a fresh row key and no database id, so it
    // is inserted rather than overwriting the line it was copied from.
    const insertClone = (prev) => {
      const clonedItem = { ...record, key: nextLineKey(prev), id: undefined };
      const index = prev.findIndex((item) => item.key === record.key);
      const newData = [...prev];
      newData.splice(index + 1, 0, clonedItem);
      return newData;
    };

    if (type === "product") {
      updateQuoteItemData(insertClone);
    } else if (type === "service") {
      updateServiceData(insertClone);
    }
  };

  const cancel = () => {
    isEditing(false);
    // form.current = null;
    setEditingKey("");
  };

  const onChange = (key) => {
    console.log(key);
    cancel();
  };

  const handleAddDocument = async (doc_ids = []) => {
    const response = await adminactions.addDocumentsToQuote(id, doc_ids);
    if (response) {
      setDocuments(response);
    }
  };

  const handleDeleteDocument = async (doc_id) => {
    const response = await adminactions.removeDocumentFromQuote(id, doc_id);
    if (response) {
      setDocuments(response);
    }
  };

  const handleDeleteAttachment = async (doc_id) => {
    const response = await adminactions.removeDocumentFromQuote(id, doc_id);
    if (response) {
      setAttachments(response);
    }
  };

  const props = {
    name: "file",
    multiple: false,
    action: process.env.REACT_APP_BASE_URL + `/quotes/quotes/${id}/addDoc/`,
    headers: { Authorization: axios.defaults.headers.common["Authorization"] },
    onChange(info) {
      console.log(info);
      const { status, response } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }

      if (response) {
        setAttachments(response);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const viewDownloadDocument = async (record, preview, download) => {
    try {
      const response = await axios.get(record.document_file, {
        responseType: "blob",
      });
      console.log({ response, record });
      if (response.status === 200) {
        if (download) {
          fileDownload(response.data, record.name);
        }
        if (preview) {
          if (record.document["extension"] === ".pdf") {
            setPdfPreviewData(response.data);
            setPreviewPdfVisible(true);
          } else {
            message.error("only pdfs can be rendered for now!");
          }
        }
      }
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const productColumns = [
    {
      title: "Item",
      dataIndex: "title",
      width: "8%",
      // editable: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: "20%",
      // editable: true,
      render: (text, record, index) => {
        return <div dangerouslySetInnerHTML={{ __html: record.description }} />;
      },
    },
    {
      title: "HSN/SAC",
      dataIndex: "hsn",
      width: "8%",
      // editable: true,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: "8%",
      // editable: true,
    },
    {
      title: "Price(per unit)",
      dataIndex: "price",
      width: "8%",
      align: "right",
      // editable: true,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: "8%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        if (record?.is_fixed_rate) {
          return <div>FIXED RATE</div>;
        } else {
          return record?.quantity;
        }
      },
    },
    {
      title: "Tax Rate",
      dataIndex: "tax_rate1",
      width: "6%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        const taxRate = taxRates.find((item) => item.id === text);
        if (taxRate) {
          return `${taxRate?.title + " " + taxRate?.rate} %`;
        }
        return null;
      },
    },
    {
      title: "Tax Rate",
      dataIndex: "tax_rate2",
      width: "6%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        const taxRate = taxRates.find((item) => item.id === text);
        if (taxRate) {
          return `${taxRate?.title + " " + taxRate?.rate} %`;
        }
        return null;
      },
    },
    {
      title: "Tax Rate",
      dataIndex: "tax_rate3",
      width: "6%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        const taxRate = taxRates.find((item) => item.id === text);
        if (taxRate) {
          return `${taxRate?.title + " " + taxRate?.rate} %`;
        }
        return null;
      },
    },
    {
      title: "Discount",
      dataIndex: "discount_value",
      width: "7%",
      align: "right",
      render: (_, record) => formatDiscount(record.discount_type, record.discount_value),
    },
    {
      title: "Line Total",
      dataIndex: "line_total",
      width: "10%",
      align: "right",
      // editable: true,
      // render: (text, record, index) => {
      //     return <div>{record.price * record.quantity}</div>
      // }
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      render: (_, record) => {
        return (
          <Space size="middle">
            <Typography.Link
              onClick={() => {
                setCurrentProductInstance(record);
                setOpenProductForm(true);
              }}
              title="Edit"
            >
              <EditOutlined />
            </Typography.Link>
            <Typography.Link
              onClick={() => cloneLineItem(record, "product")}
              title="Clone"
            >
              <CopyOutlined />
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => deleteRecord(record.key, "product")}
            >
              <Typography.Link title="Delete">
                <DeleteOutlined style={{ color: '#ff4d4f' }} />
              </Typography.Link>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];


  const documentColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a?.id.localeCompare(b?.id),
    },
    {
      title: "NAme",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => dayjs(a?.created_at) - dayjs(b?.created_at),
      render: (text, record) => {
        return <div>{dayjs(text).format("MMMM Do YYYY, h:mm:ss a")}</div>;
      },
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      sorter: (a, b) => a?.org_size - b?.org_size,
    },
    {
      title: "Linked",
      dataIndex: "is_linked",
      key: "is_linked",
      sorter: (a, b) => a?.is_linked - b?.is_linked,
      render: (_, record) => {
        const size = 8;
        const radius = "30%";
        return (
          <div className="d-flex justify-content-center align-items-center">
            {record.is_linked ? (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "green",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "red",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <span>
            <Typography.Link
              onClick={() => {
                console.log("View Document");
                viewDownloadDocument(record, true, false);
              }}
            >
              View
            </Typography.Link>
            <Typography.Link
              className="ms-2"
              onClick={() => {
                console.log("Download Document");
                viewDownloadDocument(record, false, true);
              }}
            >
              Download
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDeleteDocument(record.id)}
            >
              <a style={{ marginLeft: 10 }}>Delete</a>
            </Popconfirm>
          </span>
        );
      },
    },
  ];

  const attachmentColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a?.id.localeCompare(b?.id),
    },
    {
      title: "Name",
      dataIndex: ["document", "name"],
      key: "name",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => dayjs(a?.created_at) - dayjs(b?.created_at),
      render: (text, record) => {
        return <div>{dayjs(text).format("MMMM Do YYYY, h:mm:ss a")}</div>;
      },
    },
    {
      title: "Size",
      dataIndex: ["document", "size"],
      key: "size",
      sorter: (a, b) => a?.org_size - b?.org_size,
    },
    {
      title: "Linked",
      dataIndex: ["document", "is_linked"],
      key: "is_linked",
      sorter: (a, b) => a?.is_linked - b?.is_linked,
      render: (_, record) => {
        const size = 8;
        const radius = "30%";
        return (
          <div className="d-flex justify-content-center align-items-center">
            {record.is_linked ? (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "green",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "red",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <Flex gap="middle">
            <Typography.Link
              onClick={() => {
                console.log("View Document");
                viewDownloadDocument(record, true, false);
              }}
            >
              <EyeOutlined />
            </Typography.Link>
            <Typography.Link
              onClick={() => {
                console.log("Download Document");
                viewDownloadDocument(record, false, true);
              }}
            >
              <DownloadOutlined />
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDeleteAttachment(record.id)}
            >
              <DeleteOutlined />
            </Popconfirm>
          </Flex>
        );
      },
    },
  ];

  const TableRow = (props) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
      id: props['data-row-key'],
    });
    const style = {
      ...props.style,
      transform: transform ? CSS.Translate.toString(transform) : undefined,
      transition,
      cursor: 'move',
      ...(isDragging
        ? {
          position: 'relative',
          zIndex: 1000,
        }
        : {}),
    };
    return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        // https://docs.dndkit.com/api-documentation/sensors/pointer#activation-constraints
        distance: 1,
      },
    }),
  );
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setQuoteItemData((prev) => {
        const activeIndex = prev.findIndex((i) => i.key === active.id);
        const overIndex = prev.findIndex((i) => i.key === over?.id);
        const newArray = arrayMove(prev, activeIndex, overIndex);
        
        // Assign new priority values based on the new order
        return newArray.map((item, index) => ({
          ...item,
          priority: index + 1
        }));
      });
      
      // Mark as having unsaved changes when items are reordered
      setHasUnsavedChanges(true);
    }
  };

  const mergedColumns = productColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: ["price", "quantity", "line_total"].includes(col.dataIndex)
          ? "number"
          : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });


  const editorConfig = {
    extraPlugins: ["tableresize", "uploadimage", "createpdf"],
    removePlugins: [
      "exportpdf",
      "forms",
      "smiley",
      "language",
      "iframe",
      "about",
    ],
    // filebrowserBrowseUrl: 'http://localhost:4000/media/24b358cf-8e56-4b03-9843-29fabf589b8d/template/home-advt_jzx7KBU.jpeg',
    filebrowserImageUploadUrl:
      process.env.REACT_APP_BASE_URL + `/template/upload_template_image/`,
    fileTools_requestHeaders: axios.defaults.headers.common,
    uploadUrl:
      process.env.REACT_APP_BASE_URL + `/template/upload_template_image/`,
    contentsCss: [
      // "https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css",
      process.env.REACT_APP_BASE_URL +
      "/staticfiles/ckeditor/4.19.0/full-all/document-style.css",
      "/ckeditor-content.css",
  ],
    bodyClass: "document-editor",
    // height: 900,
    // width: 1000,
    height: "5cm",
    // width: "18.6cm",
    width: "21cm",
    allowedContent: true,
    // extraPlugins: [
    //     'timestamp'
    // ]
    // exportPdf_options: {
    //     header_html: '<div class="styled">This is the Header</div>',
    //     footer_html: '<div class="styled-counter"><span class="date></span></div>',
    //     header_and_footer_css: '.styled { font-weight: bold; padding: 10px; display: flex; color: red; } .styled-counter {font-size: 10px; color: red; }',
    //     margin_top: '2cm',
    //     margin_bottom: '10cm',
    // }
    // exportPdf_options: {
    //     format: "A3"
    // }
    exportPdf_options: {
      header_html: '<div class="styled">Header content</div>',
      footer_html: '<div class="styled"><span class="pageNumber"></span></div>',
      header_and_footer_css:
        ".styled { font-weight: bold; padding: 10px; text-align: center; color: red; }",
      margin_left: "1cm",
      margin_right: "2cm",
      format: "A5",
      page_orientation: "landscape",
    },
    protectedSource: [/{%[\s\S]*?%}+/g, /{{[\s\S]*?}}+/g],
    // formatOutput: false,
    // formatSource: false,
    // Phones get a short toolbar; desktop keeps the full grouped one.
    ...compactToolbar(),
  };

  useEffect(() => {
    loadTaxRates();
    loadQuote();
    loadAccounts();
    loadDeals();
    loadCurrencies();
    loadTesonProducts();
    // // loadProducts();
    // // loadServices();
    loadQuoteStatuses();
    loadDeliveryTimelineUnits();
    // Try to load bank accounts on mount
    loadBankAccounts();
    // Generate quote number for new quotes
    if (!id) {
      loadGeneratedQuoteNumber();
    }
  }, []);

  // Load bank accounts when organization is available
  useEffect(() => {
    // Try to load bank accounts even if organization is not set yet
    // The loadBankAccounts function has fallback logic
    loadBankAccounts(organization);
  }, [organization]);

  // Load deal data when deal parameter is in URL (for new quotes)
  useEffect(() => {
    if (dealIdFromUrl && !id) {
      loadDealById(dealIdFromUrl);
    }
  }, [dealIdFromUrl, id]);

  useEffect(() => {
    const fetchQuotePdf = async () => {
      if (openViewDrawer && dataSource?.id) {
        setPdfLoading(true);
        try {
          const response = await axios.get(
            `quotes/quotes/${dataSource.id}/quoteView/`,
            { responseType: 'blob' }
          );
          const blobUrl = URL.createObjectURL(response.data);
          setPdfUrl(blobUrl);
        } catch (error) {
          console.error('Error loading quote PDF:', error);
          message.error('Failed to load quote preview');
        } finally {
          setPdfLoading(false);
        }
      } else {
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
        setPdfUrl("");
      }
    };
    fetchQuotePdf();
  }, [openViewDrawer, dataSource?.id]);

  useEffect(() => {
    setProductCount(quoteItemData.length);
  }, [quoteItemData]);

  useEffect(() => {
    setServiceCount(serviceData.length);
  }, [serviceData]);

  useEffect(() => {
    // Switching a quote to "manual" replaces its lines with a single net
    // figure, so the lines are dropped. Loading a quote that is already manual
    // must not do that: it would clear lines the quote still has on the server
    // and the next save would delete them.
    if (loadedIsManualRef.current === isManual) {
      loadedIsManualRef.current = null;
      return;
    }
    if (isManual) {
      let tempNet = net;
      updateQuoteItemData([]);
      updateServiceData([]);
      if (!id) {
        mainForm.setFieldValue("net", tempNet);
      }
    } else {
      //TODO
    }
  }, [isManual]);

  useEffect(() => {
    let tempNet = 0,
      itemTaxes = 0,
      tempTotal = 0;
    let tempTotalTaxes = {};
    if (isManual) {
      tempNet = parseFloat(net);
      if (isNaN(tempNet)) {
        tempNet = 0;
      }
    }
    if (quoteItemData.length > 0 || serviceData.length > 0) {
      console.log(quoteItemData);
      // setNet()
      // let tempNet = quoteItemData?.reduce((n, currentRecord) => {
      //     return (n + currentRecord.line_total);
      // }, 0);
      setNet(tempNet);
      for (let i in quoteItemData) {
        tempNet += quoteItemData[i].line_total;
        console.log(quoteItemData[i].tax_rate1);
        if (quoteItemData[i].tax_rate1) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === quoteItemData[i].tax_rate1
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (quoteItemData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (quoteItemData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (quoteItemData[i].tax_rate2) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === quoteItemData[i].tax_rate2
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (quoteItemData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (quoteItemData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (quoteItemData[i].tax_rate3) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === quoteItemData[i].tax_rate3
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (quoteItemData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (quoteItemData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
      }
      for (let i in serviceData) {
        tempNet += serviceData[i].line_total;
        console.log(serviceData[i].tax_rate1);
        if (serviceData[i].tax_rate1) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === serviceData[i].tax_rate1
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (serviceData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (serviceData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (serviceData[i].tax_rate2) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === serviceData[i].tax_rate2
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (serviceData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (serviceData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (serviceData[i].tax_rate3) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === serviceData[i].tax_rate3
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (serviceData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (serviceData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
      }
      for (const [, value] of Object.entries(tempTotalTaxes)) {
        itemTaxes += value;
      }
      // Overall discount comes off the net before the quote-level taxes.
      const overallDiscount = discountAmountOf(tempNet, discountType, discountValue);
      const taxableNet = tempNet - overallDiscount;
      setDiscountAmount(overallDiscount);
      let netTaxes = 0;
      if (taxRate1) {
        const taxObj = taxRates.find((item) => item.id === taxRate1.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate2) {
        const taxObj = taxRates.find((item) => item.id === taxRate2.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate3) {
        const taxObj = taxRates.find((item) => item.id === taxRate3.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      setNet(tempNet);
      setTotalTaxes(tempTotalTaxes);
      // setSubTotal(tempNet + itemTaxes);
      let urt = parseFloat(taxableNet + itemTaxes + netTaxes).toFixed(2);
      let tot = Math.round(urt);
      let rof = (tot - urt).toFixed(2);
      setUnRoundedTotal(urt);
      setRoundValue(rof);
      setTotal(tot);
    } else {
      // setSubTotal(0);
      // Overall discount comes off the net before the quote-level taxes.
      const overallDiscount = discountAmountOf(tempNet, discountType, discountValue);
      const taxableNet = tempNet - overallDiscount;
      setDiscountAmount(overallDiscount);
      let netTaxes = 0;
      if (taxRate1) {
        const taxObj = taxRates.find((item) => item.id === taxRate1.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate2) {
        const taxObj = taxRates.find((item) => item.id === taxRate2.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate3) {
        const taxObj = taxRates.find((item) => item.id === taxRate3.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      console.log({
        ...dataSource,
        quote_date: dataSource?.quote_date
          ? dayjs(dataSource?.quote_date)
          : null,
        expiry_date: dataSource?.expiry_date
          ? dayjs(dataSource?.expiry_date)
          : null,
      });
      console.log({ tempNet, tempTotalTaxes, tempTotal, itemTaxes, netTaxes });
      setNet(tempNet);
      setTotalTaxes(tempTotalTaxes);
      // setSubTotal(tempNet + itemTaxes);
      let urt = parseFloat(taxableNet + itemTaxes + netTaxes).toFixed(2);
      let tot = Math.round(urt);
      let rof = (tot - urt).toFixed(2);
      setUnRoundedTotal(urt);
      setRoundValue(rof);
      setTotal(tot);
    }

    // Calculate total hours and days
    let tempTotalHours = 0;
    let tempTotalDays = 0;

    for (let item of quoteItemData) {
      if (item.unit === "HOURS") {
        tempTotalHours += parseFloat(item.quantity) || 0;
      } else if (item.unit === "DAYS") {
        tempTotalDays += parseFloat(item.quantity) || 0;
      }
    }

    for (let item of serviceData) {
      if (item.unit === "HOURS") {
        tempTotalHours += parseFloat(item.quantity) || 0;
      } else if (item.unit === "DAYS") {
        tempTotalDays += parseFloat(item.quantity) || 0;
      }
    }

    setTotalHours(tempTotalHours);
    setTotalDays(tempTotalDays);
  }, [quoteItemData, serviceData, taxRate1, taxRate2, taxRate3, net, discountType, discountValue]);

  // Total payable follows the currency: whole rupees for INR, cents kept for
  // other currencies (same rule as the backend's total_payable).
  useEffect(() => {
    const tot = roundPayable(unRoundedTotal, selectedCurrencyIso || "INR");
    setTotal(tot);
    setRoundValue((tot - Number(unRoundedTotal || 0)).toFixed(2));
  }, [unRoundedTotal, selectedCurrencyIso]);

  // Handle page leave confirmation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      console.log("beforeunload triggered, hasUnsavedChanges:", hasUnsavedChanges);
      if (hasUnsavedChanges) {
        console.log("Showing leave confirmation");
        e.preventDefault();
        e.returnValue = "You have unsaved changes. Are you sure you want to leave?";
        return "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    const handlePopState = (e) => {
      console.log("popstate triggered, hasUnsavedChanges:", hasUnsavedChanges);
      if (hasUnsavedChanges) {
        console.log("Showing navigation confirmation");
        const confirmLeave = window.confirm("You have unsaved changes. Are you sure you want to leave?");
        if (!confirmLeave) {
          e.preventDefault();
          window.history.pushState(null, "", window.location.href);
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    // Push current state to prevent back navigation without warning
    if (hasUnsavedChanges) {
      window.history.pushState(null, "", window.location.href);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [hasUnsavedChanges]);

  // Handle navigation attempts by overriding link clicks
  useEffect(() => {
    const handleLinkClick = (e) => {
      // Check if it's a navigation link
      const target = e.target.closest('a[href]');
      if (target && hasUnsavedChanges) {
        const href = target.getAttribute('href');
        // Only block internal navigation links, not external ones
        if (href && href.startsWith('/') && href !== window.location.pathname) {
          console.log("Navigation link clicked, checking for unsaved changes");
          if (!window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }
      }
    };

    document.addEventListener('click', handleLinkClick, true);
    return () => {
      document.removeEventListener('click', handleLinkClick, true);
    };
  }, [hasUnsavedChanges]);

  // Track form changes
  const handleFormChange = () => {
    console.log("Form changed - setting unsaved changes to true");
    setHasUnsavedChanges(true);
  };

  // Every user-driven change to the lines goes through these, so the unsaved
  // flag never depends on watching state that a reload also touches.
  const updateQuoteItemData = (newData) => {
    console.log("Quote items changed - setting unsaved changes to true");
    setQuoteItemData(newData);
    setHasUnsavedChanges(true);
  };

  const updateServiceData = (newData) => {
    setServiceData(newData);
    setHasUnsavedChanges(true);
  };

  // Handle importing quote lines from Excel.
  // "replace" makes the file the whole list, so a row deleted in Excel removes
  // that line. "append" keeps the existing lines and adds to them. Either way a
  // row carrying an id updates that line in place instead of duplicating it.
  const handleImportQuoteLines = (items, mode = "append") => {
    const existing = mode === "replace" ? [] : [...quoteItemData];
    const byId = new Map(
      quoteItemData.filter((line) => line.id).map((line) => [line.id, line])
    );

    let key = nextLineKey(quoteItemData);
    let updatedCount = 0;
    let addedCount = 0;
    const merged = existing;

    items.forEach((item) => {
      const previous = item.id ? byId.get(item.id) : undefined;
      const existingIndex = previous
        ? merged.findIndex((line) => line.id === item.id)
        : -1;

      if (previous) {
        const updated = {
          ...previous,
          ...item,
          key: previous.key,
          id: previous.id,
          quote: id,
        };
        if (existingIndex !== -1) {
          merged[existingIndex] = updated;
        } else {
          merged.push(updated);
        }
        updatedCount += 1;
      } else {
        // Dropping the id here matters: an id we do not recognise would make
        // the backend reject the save rather than add the line.
        const { id: importedId, ...rest } = item;
        merged.push({ ...rest, key: key++, quote: id });
        addedCount += 1;
      }
    });

    const removedCount =
      mode === "replace"
        ? quoteItemData.filter(
            (line) => !merged.some((kept) => kept.key === line.key)
          ).length
        : 0;

    updateQuoteItemData(merged.map((line, index) => ({ ...line, priority: index + 1 })));
    setImportModalOpen(false);

    const parts = [];
    if (addedCount) parts.push(`${addedCount} added`);
    if (updatedCount) parts.push(`${updatedCount} updated`);
    if (removedCount) parts.push(`${removedCount} removed`);
    message.success(
      `${items.length} quote line(s) imported` +
        (parts.length ? ` (${parts.join(", ")})` : "")
    );
  };

  // Export this quote's lines so they can be edited in Excel and imported back.
  const handleExportQuoteLines = async () => {
    setExporting(true);
    try {
      await exportQuoteLines(id);
    } catch (err) {
      console.error("Failed to export quote lines:", err);
    } finally {
      setExporting(false);
    }
  };

  // The unsaved-changes flag is set by the handlers that actually change
  // something. Watching quoteItemData/net/total instead raised the flag on
  // every load and re-raised it straight after a successful save, since both
  // recompute those values.

  return (
    <div
      className="custom-scroll-div"
      style={{
        overflowY: "scroll",
        maxHeight: "90vh",
        padding: 10,
        paddingBottom: 30,
      }}
    >
      {!loading && (
        <Form
          form={mainForm}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 18 }}
          onFinish={onFinish}
          onValuesChange={handleFormChange}
          initialValues={{
            ...dataSource,
            quote_date: dataSource?.quote_date
              ? dayjs(dataSource?.quote_date)
              : null,
            expiry_date: dataSource?.expiry_date
              ? dayjs(dataSource?.expiry_date)
              : null,
          }}
        >
          <Flex justify="end" gap="middle" style={{ margin: "10px auto" }}>
            {id && (
              <>
                {!isManual && (
                  <Button
                    htmlType="button"
                    icon={<PrinterOutlined />}
                    onClick={() => {
                      setOpenViewDrawer(true);
                    }}
                  >
                    Print Quote
                  </Button>
                )}
                {!isManual && (
                  <Button
                    htmlType="button"
                    onClick={() => previewDownloadPdf(false, true)}
                  >
                    Download Quote
                  </Button>
                )}
                {!isManual && (
                  <Button
                    htmlType="button"
                    onClick={() => cloneQuote(id)}
                  >
                    Clone
                  </Button>
                )}
                {!isManual && (
                  <Button
                    htmlType="button"
                    onClick={() => convertToInvoice(id)}
                  >
                    Convert to Invoice
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={() => setOpenSendDrawer(true)}
                >
                  Send Quote
                </Button>
                <Button
                  htmlType="button"
                  onClick={() => setOpenViewDrawer(true)}
                >
                  View Quote
                </Button>
              </>
            )}
            <Button type="primary" htmlType="submit" loading={submitting}>
              Save
            </Button>
          </Flex>

          <Row>
            <Col span={6}>
              <div className="site-card-border-less-wrapper">
                <Card title="Account" bordered={false}>
                  <div>
                    <Form.Item
                      label="Account"
                      name="account"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select Account"
                        optionFilterProp="children"
                        onChange={(value) => {
                          onAccountChange(value);
                          // Filter deals by selected account
                          loadDeals(value);
                          // Clear deal selection when account changes
                          mainForm.setFieldValue("deal", null);
                        }}
                        onSearch={onAccountSearch}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={accounts?.map((item, index) => {
                          return { value: item.id, label: item.name };
                        })}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label="Deal"
                      name="deal"
                    >
                      <Select
                        showSearch
                        placeholder="Select Deal (Optional)"
                        optionFilterProp="children"
                        allowClear
                        disabled={!!dealIdFromUrl && !id}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={deals?.map((item, index) => {
                          return { value: item.id, label: item.deal_name };
                        })}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label="Product"
                      name="product"
                      tooltip="Tag this quote to a Teson product (e.g. SignVerse, PhotoStore). Optional."
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select Product (Optional)"
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={tesonProducts?.map((item) => ({
                          value: item.id,
                          label: item.code ? `${item.name} (${item.code})` : item.name,
                        }))}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label="Status"
                      name="status"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="Select Status"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={quoteStatuses.map((item, index) => {
                          return { value: item[0], label: item[0] };
                        })}
                      />
                    </Form.Item>
                  </div>
                </Card>
              </div>
            </Col>
            <Col span={8} style={{ padding: "0px 0px 10px 10px" }}>
              <div className="site-card-border-less-wrapper">
                <Card bordered={false}>
                  <Form.Item label="Quote Date" name="quote_date">
                    <DatePicker />
                  </Form.Item>
                  <Form.Item label="Expiry Date" name="expiry_date">
                    <DatePicker />
                  </Form.Item>
                  <Form.Item
                    label="Timeline Unit"
                    name="delivery_timeline_unit"
                  >
                    <Select
                      placeholder="Delivery Unit"
                      options={deliveryTimelineUnits.map((item, index) => {
                        return { value: item[0], label: item[0] };
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Timeline" name="delivery_timeline">
                    <InputNumber />
                  </Form.Item>
                  <Form.Item label="Currency" name="currency">
                    <Select
                      showSearch
                      placeholder="Select Currency"
                      optionFilterProp="label"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={currencies.map((currency) => ({
                        value: currency.id,
                        label: `${currency.currency} (${currency.iso_code})`,
                      }))}
                      onChange={(value) => {
                        const curr = currencies.find((c) => c.id === value);
                        if (!curr || curr.iso_code === "INR") {
                          mainForm.setFieldsValue({ exchange_rate: 1.0 });
                        }
                      }}
                    />
                  </Form.Item>
                  {isForeignCurrency && (
                    <Form.Item
                      label={<span style={{ whiteSpace: 'normal' }}>Exchange Rate</span>}
                      name="exchange_rate"
                      rules={[{ required: true, message: "Please enter the exchange rate" }]}
                    >
                      <ExchangeRateInput
                        currencyIso={selectedCurrencyIso}
                        savedRate={
                          dataSource?.currency && dataSource.currency === selectedCurrencyId
                            ? dataSource.exchange_rate
                            : undefined
                        }
                      />
                    </Form.Item>
                  )}
                </Card>
              </div>
            </Col>
            <Col span={10} style={{ padding: "0px 0px 10px 10px" }}>
              <div className="site-card-border-less-wrapper">
                <Card bordered={false}>
                  <Form.Item
                    label="Quote Number"
                    name="qt_number"
                    labelCol={{ span: 8 }}
                  >
                    <Input
                      suffix={
                        <Button
                          type="text"
                          icon={<ReloadOutlined />}
                          onClick={loadGeneratedQuoteNumber}
                          size="small"
                          title="Generate current quote number"
                        />
                      }
                    />
                  </Form.Item>
                  <Form.Item label="Title" name="title" labelCol={{ span: 8 }}>
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Is Manual"
                    name="is_manual"
                    valuePropName="checked"
                    labelCol={{ span: 8 }}
                  >
                    <Switch
                      onChange={(value) => setIsManual(value)}
                      disabled={id ? true : false}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ whiteSpace: 'normal' }}>Org Bank Account</span>}
                    name="org_bank_account"
                    rules={[{ required: true, message: "Please select an organization bank account!" }]}
                  >
                    <Select
                      placeholder="Select Org Bank Account"
                      options={bankAccounts.map((org_bank_account) => ({
                        value: org_bank_account.id,
                        label: `${org_bank_account.account_name} (${org_bank_account.bank_name} ${org_bank_account.account_number})`,
                      }))}
                    />
                  </Form.Item>
                </Card>
              </div>
            </Col>
          </Row>

          {/* Quote Options Section */}
          <Row style={{ marginTop: 10 }}>
            <Col span={24}>
              <Card title="Quote Options" bordered={false}>
                <Row gutter={24}>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      label="Show Bank Details"
                      name="show_bank_details"
                      valuePropName="checked"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      label="Computer Generated"
                      name="is_computer_generated"
                      valuePropName="checked"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      label="Authorized Signature"
                      name="is_authorized_signature_required"
                      valuePropName="checked"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              {!isManual && (
                <div className="site-card-border-less-wrapper">
                  <Card bordered={false} style={{}}>
                    <Tabs
                      defaultActiveKey="1"
                      onChange={onChange}
                      tabBarExtraContent={
                        <Space>
                          {/* Exporting needs a saved quote to read the lines from. */}
                          <Button
                            onClick={handleExportQuoteLines}
                            icon={<DownloadOutlined />}
                            loading={exporting}
                            disabled={!id || quoteItemData.length === 0}
                            title={
                              !id
                                ? "Save the quote before exporting its lines"
                                : "Download these lines as Excel, edit them, and import the file back"
                            }
                          >
                            Export to Excel
                          </Button>
                          <Button
                            onClick={() => setImportModalOpen(true)}
                            icon={<InboxOutlined />}
                          >
                            Import from Excel
                          </Button>
                        </Space>
                      }
                      items={[
                        {
                          label: `Quote Lines`,
                          key: "1",
                          children: (
                            <div>
                              <Form form={productForm} component={false}>
                                <DndContext sensors={sensors} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
                                  <SortableContext
                                    // rowKey array
                                    items={quoteItemData?.map((i) => i.key)}
                                    strategy={verticalListSortingStrategy}
                                  >
                                    <Table
                                      // components={{
                                      //     body: {
                                      //         cell: ProductEditableCell,
                                      //     },
                                      // }}
                                      components={{
                                        body: {
                                          row: TableRow,
                                        },
                                      }}
                                      dataSource={quoteItemData}
                                      columns={mergedColumns}
                                      rowClassName="editable-row"
                                      size="small"
                                      pagination={false}
                                      rowKey={(row) => row.key}
                                      style={{ position: 'relative', zIndex: 1 }}
                                    />
                                  </SortableContext>
                                </DndContext>
                                <Button
                                  onClick={() => {
                                    setCurrentProductInstance(null);
                                    productForm.resetFields();
                                    setOpenProductForm(true);
                                  }}
                                  type="primary"
                                  style={{ marginBottom: 16 }}
                                >
                                  Add Item
                                </Button>
                              </Form>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </Card>
                </div>
              )}
              {isManual && (
                <div className="site-card-border-less-wrapper">
                  <Row>
                    <Col span={8}>
                      <Card bordered={false}>
                        <Form.Item label="Net" name="net">
                          <Input
                            onChange={(e) => {
                              setNet(e.target.value);
                            }}
                          />
                        </Form.Item>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}
            </Col>
          </Row>
          <Row style={{ padding: "10px 0px 0px 0px" }}>
            <Col span={16}>
              {id && (
                <div className="site-card-border-less-wrapper">
                  <Card bordered={false} style={{}}>
                    <Tabs
                      defaultActiveKey="1"
                      onChange={onChange}
                      items={[
                        {
                          label: `Public Notes`,
                          key: "1",
                          children: (
                            <div>
                              <Form.Item
                                valuePropName="data"
                                name="public_notes"
                                getValueFromEvent={(event) => {
                                  const data = event.editor.getData();
                                  return data;
                                }}
                              >
                                <CKEditor
                                  initData={
                                    dataSource
                                      ? dataSource.public_notes
                                      : "<p>Create your Template here!</p>"
                                  }
                                  config={editorConfig}
                                  editorUrl={
                                    process.env.REACT_APP_BASE_URL +
                                    "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"
                                  }
                                />
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          label: `Private Notes`,
                          key: "2",
                          children: (
                            <div>
                              <Form.Item
                                valuePropName="data"
                                name="private_notes"
                                getValueFromEvent={(event) => {
                                  const data = event.editor.getData();
                                  return data;
                                }}
                              >
                                <CKEditor
                                  initData={
                                    dataSource
                                      ? dataSource.private_notes
                                      : "<p>Create your Template here!</p>"
                                  }
                                  config={editorConfig}
                                  editorUrl={
                                    process.env.REACT_APP_BASE_URL +
                                    "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"
                                  }
                                />
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          label: `Terms`,
                          key: "3",
                          children: (
                            <div>
                              <Form.Item
                                valuePropName="data"
                                name="terms"
                                getValueFromEvent={(event) => {
                                  const data = event.editor.getData();
                                  return data;
                                }}
                              >
                                <CKEditor
                                  initData={
                                    dataSource
                                      ? dataSource.terms
                                      : "<p>Create your Template here!</p>"
                                  }
                                  config={editorConfig}
                                  editorUrl={
                                    process.env.REACT_APP_BASE_URL +
                                    "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"
                                  }
                                />
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          label: `Footer`,
                          key: "4",
                          children: (
                            <div>
                              <Form.Item
                                valuePropName="data"
                                name="footer"
                                getValueFromEvent={(event) => {
                                  const data = event.editor.getData();
                                  return data;
                                }}
                              >
                                <CKEditor
                                  initData={
                                    dataSource
                                      ? dataSource.footer
                                      : "<p>Create your Template here!</p>"
                                  }
                                  config={editorConfig}
                                  editorUrl={
                                    process.env.REACT_APP_BASE_URL +
                                    "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"
                                  }
                                />
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          label: `Documents`,
                          key: "5",
                          children: (
                            <div>
                              <Row>
                                <Col span={12}>
                                  <DocumentPicker
                                    selectDocuments={handleAddDocument}
                                  />
                                </Col>
                                <Col span={12}>
                                  <Dragger {...props}>
                                    <p className="ant-upload-drag-icon">
                                      <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                      Click or drag file to this area to upload
                                    </p>
                                    <p className="ant-upload-hint">
                                      Support for a single or bulk upload.
                                      Strictly prohibit from uploading company
                                      data or other band files
                                    </p>
                                  </Dragger>
                                </Col>
                              </Row>
                              <Table
                                dataSource={documents}
                                columns={documentColumns}
                                rowClassName="editable-row"
                                size="small"
                                pagination={false}
                              />
                            </div>
                          ),
                        },
                        {
                          label: `Attachments`,
                          key: "6",
                          children: (
                            <div>
                              <Row>
                                <Col span={12}>
                                  <DocumentPicker
                                    selectDocuments={handleAddDocument}
                                  />
                                </Col>
                                <Col span={12}>
                                  <Dragger {...props}>
                                    <p className="ant-upload-drag-icon">
                                      <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                      Click or drag file to this area to upload
                                    </p>
                                    <p className="ant-upload-hint">
                                      Support for a single or bulk upload.
                                      Strictly prohibit from uploading company
                                      data or other band files
                                    </p>
                                  </Dragger>
                                </Col>
                              </Row>
                              <Table
                                dataSource={attachments}
                                columns={attachmentColumns}
                                rowClassName="editable-row"
                                size="small"
                                pagination={false}
                              />
                            </div>
                          ),
                        },
                        // {
                        //     label: `Bank Information`,
                        //     key: '7',
                        //     children:
                        //         (<div
                        //         >
                        //             <Form.Item label="Bank Account Number" name='bank_account_number'>
                        //                 <Input />
                        //             </Form.Item>
                        //             <Form.Item label="Bank Name" name='bank_name'>
                        //                 <Input />
                        //             </Form.Item>
                        //             <Form.Item label="IFSC Code" name='bank_ifsc'>
                        //                 <Input />
                        //             </Form.Item>
                        //             <Form.Item label="Bank Branch" name='bank_branch'>
                        //                 <Input />
                        //             </Form.Item>
                        //         </div>),
                        // },
                      ]}
                    />
                  </Card>
                </div>
              )}
            </Col>
            <Col span={8} style={{ padding: "0px 0px 10px 10px" }}>
              <div className="site-card-border-less-wrapper">
                {(totalHours > 0 || totalDays > 0) && (
                  <Card bordered={false} style={{ marginBottom: 10,textAlign:"left" }}>
                    <h2>Timeline</h2>
                    {totalHours > 0 && (
                      <Form.Item label="Total Hours" style={{marginBottom:0}}>
                        <span>{totalHours}</span>
                      </Form.Item>
                    )}
                    {totalDays > 0 && (
                      <Form.Item label="Total Days" style={{marginBottom:0}}>
                        <span>{totalDays}</span>
                      </Form.Item>
                    )}
                  </Card>
                )}
                <Card bordered={false} style={{textAlign:"left"}}>
                  <Form.Item label="Net" >
                    <span>{net}</span>
                  </Form.Item>
                  <Form.Item label="Discount Type" name="discount_type">
                    <Select
                      placeholder="No discount"
                      allowClear
                      options={DISCOUNT_TYPE_OPTIONS}
                      onChange={(value) => {
                        if (!value) {
                          mainForm.setFieldsValue({ discount_value: null });
                        }
                      }}
                    />
                  </Form.Item>
                  {discountType && (
                    <Form.Item
                      label="Discount"
                      name="discount_value"
                      rules={[{ required: true, message: "Please enter the discount" }]}
                    >
                      <InputNumber
                        min={0}
                        max={discountType === "PERCENT" ? 100 : undefined}
                        step={0.01}
                        precision={2}
                        style={{ width: "100%" }}
                        addonAfter={discountType === "PERCENT" ? "%" : undefined}
                      />
                    </Form.Item>
                  )}
                  {discountAmount > 0 && (
                    <>
                      <Form.Item label="Discount Amount">
                        <span>-{Number(discountAmount).toFixed(2)}</span>
                      </Form.Item>
                      <Form.Item label="Net after Discount">
                        <span>{(Number(net) - Number(discountAmount)).toFixed(2)}</span>
                      </Form.Item>
                    </>
                  )}
                  <div>
                    {getTaxes(Object.entries(totalTaxes)).map((item) => {
                      return (
                        <Form.Item label={item.key}>
                          <span>{item.value}</span>
                        </Form.Item>
                      );
                    })}
                  </div>
                  {/* <Form.Item label="Sub Total">
                                    <span>{subtotal}</span>
                                </Form.Item> */}
                  <Form.Item label="Tax" name="tax_rate1">
                    <Select
                      showSearch
                      placeholder="Select Tax Rate"
                      optionFilterProp="children"
                      allowClear
                      onChange={(value) => {
                        const taxRate = taxRates.find(
                          (item) => item.id === value
                        );
                        console.log(taxRate);
                        setTaxRate1(taxRate);
                        // form.setFieldsValue({ "description": product?.notes, "price": product?.price, "quantity": 1, "line_total": product?.price });
                      }}
                      onSearch={onAccountSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={taxRates?.map((item, index) => {
                        return {
                          value: item.id,
                          label: `${item.title + " " + item.rate} %`,
                        };
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Tax" name="tax_rate2">
                    <Select
                      showSearch
                      placeholder="Select Tax Rate"
                      optionFilterProp="children"
                      allowClear
                      onChange={(value) => {
                        const taxRate = taxRates.find(
                          (item) => item.id === value
                        );
                        console.log(taxRate);
                        // form.setFieldsValue({ "description": product?.notes, "price": product?.price, "quantity": 1, "line_total": product?.price });
                        setTaxRate2(taxRate);
                      }}
                      onSearch={onAccountSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={taxRates?.map((item, index) => {
                        return {
                          value: item.id,
                          label: `${item.title + " " + item.rate} %`,
                        };
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Tax" name="tax_rate3">
                    <Select
                      showSearch
                      placeholder="Select Tax Rate"
                      optionFilterProp="children"
                      allowClear
                      onChange={(value) => {
                        const taxRate = taxRates.find(
                          (item) => item.id === value
                        );
                        console.log(taxRate);
                        setTaxRate3(taxRate);
                        // form.setFieldsValue({ "description": product?.notes, "price": product?.price, "quantity": 1, "line_total": product?.price });
                      }}
                      onSearch={onAccountSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={taxRates?.map((item, index) => {
                        return {
                          value: item.id,
                          label: `${item.title + " " + item.rate} %`,
                        };
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Total:">
                    <span>{unRoundedTotal}</span>
                  </Form.Item>
                  <Form.Item label="Round off:">
                    <span>{roundValue}</span>
                  </Form.Item>
                  <Form.Item label="Rounded total:">
                    <span>{total}</span>
                  </Form.Item>
                  {/* Internal minimum floor price; not printed on the quote PDF. */}
                  <Form.Item
                    label="Boundary price:"
                    name="boundary_price"
                    tooltip="Minimum floor price for this quote. Internal only, not shown on the PDF."
                    rules={[
                      {
                        validator: (_, value) =>
                          value !== null && value !== undefined && value !== "" &&
                          Number(total) < Number(value)
                            ? Promise.reject(
                                new Error("Rounded total is below the boundary price")
                              )
                            : Promise.resolve(),
                      },
                    ]}
                  >
                    <InputNumber
                      min={0}
                      step={0.01}
                      precision={2}
                      style={{ width: "100%" }}
                      placeholder="Minimum price"
                    />
                  </Form.Item>
                  {boundaryPrice !== null && boundaryPrice !== undefined &&
                    Number(total) < Number(boundaryPrice) && (
                      <div style={{ color: "#ff4d4f", marginTop: -12 }}>
                        Rounded total ({total}) is below the boundary price ({boundaryPrice}).
                      </div>
                    )}
                </Card>
              </div>
            </Col>
          </Row>
        </Form>
      )}

      {/* Pdf Preview Modal Start */}
      <PdfPreviewModal
        numPages={numPages}
        onDocumentLoadSuccess={events.onDocumentLoadSuccess}
        pdfPreviewData={pdfPreviewData}
        previewPdfVisible={previewPdfVisible}
        setPreviewPdfVisible={setPreviewPdfVisible}
      />
      {/* Pdf Preview Modal End */}

      <Drawer
        title={`${"Send Quote"}`}
        placement="right"
        size={"large"}
        onClose={() => setOpenSendDrawer(false)}
        open={openSendDrawer}
        style={{ zIndex: 99999 }}
        width="50%"
        extra={
          <Space>
            <Button onClick={() => setOpenSendDrawer(false)}>Cancel</Button>
          </Space>
        }
      >
        {openSendDrawer && <SendQuoteDrawer instance={dataSource} />}
      </Drawer>

      {/* Product Modal Start */}
      <Drawer
        title={`${currentProductInstance ? "Edit" : "Add"} Product`}
        placement="right"
        width={"35%"}
        onClose={() => {
          setCurrentProductInstance(null);
          setOpenProductForm(false);
          productForm.resetFields();
        }}
        open={openProductForm}
        style={{ zIndex: 99999 }}
      >
        <QuoteLineForm
          quoteId={id}
          quoteItemData={quoteItemData}
          setQuoteItemData={updateQuoteItemData}
          taxRates={taxRates}
          instance={currentProductInstance}
          form={productForm}
          reload={() => {
            setCurrentProductInstance(null);
            setOpenProductForm(false);
            productForm.resetFields();
          }}
        />
      </Drawer>
      {/* Product Modal End */}

      {/* Service Modal Start */}
      <Drawer
        title={`${currentServiceInstance ? "Edit" : "Add"} Service`}
        placement="right"
        width={"35%"}
        onClose={() => {
          setCurrentServiceInstance(null);
          setOpenServiceForm(false);
          serviceForm.resetFields();
        }}
        open={openServiceForm}
        style={{ zIndex: 99999 }}
      >
        <QuoteServiceForm
          quoteId={id}
          serviceData={serviceData}
          setServiceData={updateServiceData}
          taxRates={taxRates}
          instance={currentServiceInstance}
          form={serviceForm}
          reload={() => {
            setCurrentServiceInstance(null);
            setOpenServiceForm(false);
            serviceForm.resetFields();
          }}
        />
      </Drawer>
      {/* Service Modal End */}

      {/* Drawer for Quote Details */}
      <Drawer
        title={`Quote Details - ${dataSource?.qt_number ?? ""}`}
        placement="right"
        onClose={() => setOpenViewDrawer(false)}
        open={openViewDrawer}
        width={"50%"}
        extra={
          <PreviewDrawerActions
            onPrint={
              dataSource && !isManual
                ? () => {
                    if (pdfUrl) {
                      const printWindow = window.open(pdfUrl);
                      if (printWindow) {
                        printWindow.addEventListener('load', () => {
                          printWindow.print();
                        });
                      }
                    }
                  }
                : undefined
            }
            printDisabled={!pdfUrl || pdfLoading}
            onDownload={
              dataSource && !isManual
                ? () => previewDownloadPdf(false, true)
                : undefined
            }
            onClose={() => setOpenViewDrawer(false)}
          />
        }
      >
        {/* Render quote details here */}
        {/* Embed PDF */}
        {pdfLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin size="large" />
          </div>
        ) : pdfUrl && (
          <PdfViewer
            url={pdfUrl}
            title="Quote PDF"
            onDownload={() => previewDownloadPdf(false, true)}
          />
        )}
      </Drawer>

      {/* Import Quote Lines Modal */}
      <ImportQuoteLinesModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onImport={handleImportQuoteLines}
        onExport={handleExportQuoteLines}
        taxRates={taxRates}
        quoteId={id}
        canExport={!!id && quoteItemData.length > 0}
      />
    </div>
  );
};
export default QuoteForm;
